// Gen-API patientmanagement Rest URL
export const BaseRestUrl = "/patientmanagement/rest";

// PAM Service V1 Rest URL
export const PAMV1RestUrl = `${BaseRestUrl}/pam-api/api/v1`;
export const PAMV2RestUrl = `${BaseRestUrl}/pam-api/api/v2`;
